<template>
  <b-modal
    id="phoneUpdateModal"
    modal-class="client-details-modal"
    centered
    size="lg"
    hide-footer
    :visible="isOpen"
    @hidden="closeModal"
    @hide="closeModal"
  >
    <template #modal-header style="border-bottom: 0px">
      <div class="view-clients-header">
        <b-button variant="close-btn close-option" @click="closeModal">
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </template>
    <b-container fluid>
      <div class="view-clients-modal-content">
        <h6>Edit Phone Information</h6>
        <div class="addMessage-form">
          <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
            <form
              @submit.stop.prevent="handleSubmit(updatePhone)"
              ref="updatePhoneContainer"
            >
              <div>
                <div class="form-group row p-0 m-0">
                  <div class="col-md-12 p-0 mb-3">
                    <input-text
                      :rules="{ required: true }"
                      labelFor="phone_1"
                      labelName="Primary Phone"
                      inputName="phone_1"
                      inputType="tel"
                      :vmodel.sync="form.phone_1"
                      class="input-fld p-0"
                    />
                  </div>
                  <div class="col-md-12 p-0">
                    <input-text
                      labelFor="phone_2"
                      labelName="Secondary Phone"
                      inputName="phone_2"
                      inputType="tel"
                      :vmodel.sync="form.phone_2"
                      class="input-fld p-0"
                    />
                  </div>

                  <div class="col-xxl-12 col-md-12 mb-3 p-0 mt-3">
                    <div class="row justify-content-md-center">
                      <div class="col-xxl-5 mb-4">
                        <b-button class="btn btn-email-send custom-update-btn" type="submit" :disabled="isUpdating">
                          <template v-if="isUpdating"> Updating... </template>
                          <template v-else :disabled="invalid"> Update </template>
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import axios from "axios";
import Helper from "@/resource/Helper";

export default {
  name: "PhoneUpdateModal",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    memberData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        phone_1: "",
        phone_2: "",
        userId: null,
        is_verified: false
      },
      isUpdating: false
    };
  },
  watch: {
    isOpen(val) {
    if (val && this.memberData) {
      this.form.phone_1 = this.memberData.phone_1 || "";
      this.form.phone_2 = this.memberData.phone_2 || "";
      this.form.userId = this.memberData.user_id || this.memberData.id;
    }
  },
  memberData: {
    immediate: true,
    handler(newVal) {
      if (newVal) {
        this.form.phone_1 = newVal.phone_1 || "";
        this.form.phone_2 = newVal.phone_2 || "";
        this.form.userId = newVal.user_id || newVal.id;
      }
    }
  }
  },
  mounted() {
    if (this.memberData) {
      this.form.phone_1 = this.memberData.phone_1 || "";
      this.form.phone_2 = this.memberData.phone_2 || "";
      this.form.userId = this.memberData.user_id || this.memberData.id;
    }
  },
  methods: {
    reset() {
      this.form = {
        phone_1: "",
        phone_2: "",
        userId: null,
        is_verified: false
      };
      this.$refs.observer.reset();
    },
    closeModal() {
      this.reset();
      this.$emit("close");
    },
    updatePhone() {
        if (!this.form.userId) {
    this.$notify("User ID is missing", "error");
    return;
  }
  const url = process.env.VUE_APP_API_URL_V2 + "update-groupphone-info";
  this.isUpdating = true;
  
  let loader = this.$loading.show({
    container: this.$refs.updatePhoneContainer,
  });
  
  // Correct payload structure based on API expectations
  const payload = {
    phone_1: this.form.phone_1,  // Changed to match API expectation
    phone_2: this.form.phone_2 || "",  // Changed to match API expectation
     userId: this.form.userId,  // Changed to match API expectation
    is_verified: this.form.is_verified
  };
  
  axios.post(url, payload)
    .then((res) => {
      this.$notify(res.data.message || "Phone information updated successfully");
      this.memberData.phone_1 = this.form.phone_1;
      this.memberData.is_phone_valid = true;
      this.$emit("reloadInfo");
      this.closeModal();
    })
    .catch((err) => {
      const errorMsg = err.response?.data?.message || "Failed to update phone information";
      this.$notify(errorMsg, "error");
      // Log detailed error for debugging
      console.error("Phone update error:", {
        error: err.response?.data,
        payload: payload
      });
    })
    .finally(() => {
      this.isUpdating = false;
      loader.hide();
    });
}
  }
};
</script>
<style scoped>
.custom-update-btn {
  background-color: #1392b8 !important; /* or any color you want */
  color: white;
  border: none;
}

.custom-update-btn:hover {
  background-color: #1392b8;
}
</style>